import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Prop, Component, Vue, Inject } from 'vue-property-decorator';
import { SCSSEditor } from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleTemplate/ScssEditor";
import StyleNameHeader from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleNameHeader";
import { message } from 'ant-design-vue';
import { compileSCSS, scss2ExtraStyle } from "../../../../../../lib/utils/styling";
import * as styles from "./index.module.css";
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import { unset, cloneDeep } from "lodash-es";
import { toCamelCase } from "../../../../../../lib/utils";
const HelpText = `
      抽出组件样式: 装入样式模板的样式将从原组件中移除
      `;
const walkExtraStyle = extraStyle => {
  const walkAns = [];
  Object.entries(extraStyle).forEach(([selector, pseudoClasses]) => {
    Object.entries(pseudoClasses).forEach(([pseudo, cssObj]) => {
      Object.entries(cssObj).forEach(([cssProp, cssValue]) => {
        walkAns.push({
          path: [selector, pseudo, toCamelCase(cssProp)],
          value: cssValue
        });
      });
    });
  });
  return walkAns;
};
const DefaultCollectMethod = 'copy';
const EmptyStyleSheet = {
  id: '',
  name: '',
  source: ''
};
/** 编辑/新建一个StyleSheet emit出编辑后的结果 和新建所需的配置项 */
let StyleSheetEditModal = class StyleSheetEditModal extends Vue {
  constructor() {
    super(...arguments);
    this.modalVisible = false;
    this.styleSheetInternal = EmptyStyleSheet;
    this.collectMethod = DefaultCollectMethod;
    /** 用来高亮保存按钮 */
    this.styleSheetInternalChanged = false;
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  resetChanged() {
    this.$nextTick(() => this.styleSheetInternalChanged = false);
  }
  open(styleSheet, opts = {}) {
    this.styleSheetInternal = cloneDeep(styleSheet);
    this.modalVisible = true;
    this.resetChanged();
    this.warningText = opts.warning;
  }
  created() {
    this.$watch('modalVisible', () => this.collectMethod = DefaultCollectMethod);
    this.$watch('styleSheetInternal', () => this.styleSheetInternalChanged = true, {
      deep: true
    });
  }
  get title() {
    return this.isCreateNew ? '新建样式模板' : '编辑样式模板';
  }
  close() {
    this.modalVisible = false;
  }
  isDuplicateName(name) {
    // 有点耦合 不过只做查询应该不会失控
    const nameList = this.designer.stylePanelState.styleSheetList.map(item => item.name.trim());
    return nameList.includes(name);
  }
  checkCanSave() {
    if (this.styleSheetInternal.source.trim().length === 0) {
      message.warn('空样式内容');
      return false;
    }
    if (this.styleSheetInternal.name.trim().length === 0) {
      message.warn('空样式名字');
      return false;
    }
    if (this.isCreateNew && this.isDuplicateName(this.styleSheetInternal.name)) {
      // 检查新建重名
      message.warn('已存在同名样式模板');
      return false;
    }
    // 简单做一次编译检查
    const compiled = compileSCSS(`.${this.styleSheetInternal.id}{\n${this.styleSheetInternal.source}\n}`);
    if (compiled.trim().length === 0) {
      message.warn('样式格式非法');
      return false;
    }
    return true;
  }
  async submitStyleSheet() {
    if (!this.checkCanSave()) {
      return;
    }
    const opts = {};
    if (this.isCreateNew) {
      opts.collectMethod = this.collectMethod;
    }
    await this.saveStyleSheet(this.styleSheetInternal, opts);
    this.resetChanged();
    this.close();
  }
  async saveStyleSheet(styleSheet, opts) {
    this.stylePanelState.commitStyleSheet(styleSheet);
    // 如果是新建 要挂载+尝试抽取
    if (!this.isCreateNew) return;
    await this.stylePanelState.mountStyleSheet(styleSheet.id, this.designer.compPath);
    if (opts.collectMethod === 'pull') {
      // 重新编译 看哪些被拿出来了
      const extStyle = scss2ExtraStyle(styleSheet.source);
      // 清理组件的原有的样式
      await this.designer.modifyComp(this.designer.compPath, comp => {
        walkExtraStyle(extStyle).forEach(({
          path
        }) => {
          const isRoot = path[0] === '' && path[1] === '';
          const stylePath = isRoot ? ['style', ...path.slice(2)] : ['extraStyle', ...path];
          unset(comp, stylePath);
        });
      });
    }
  }
  renderModalContext() {
    const h = this.$createElement;
    return h("div", {
      "class": styles.editModalContext
    }, [this.warningText && h("a-alert", {
      "attrs": {
        "message": this.warningText,
        "banner": true
      }
    }), h("a-input", _mergeJSXProps([{
      "attrs": {
        "placeholder": "模板名字",
        "value": this.styleSheetInternal.name
      }
    }, {
      "on": {
        'change.value': ev => this.$set(this.styleSheetInternal, 'name', ev.trim())
      }
    }])), h("div", [h(SCSSEditor, {
      "attrs": {
        "value": this.styleSheetInternal.source
      },
      "on": {
        "change": ev => this.$set(this.styleSheetInternal, 'source', ev)
      }
    })]), this.isCreateNew ? h("div", [h("style-name-header", {
      "attrs": {
        "name": "样式收集方式:",
        "helpText": HelpText,
        "helpTextZIndex": 1500
      }
    }, [h("div", {
      "style": "margin-top:8px"
    }, [h("a-radio-group", {
      "model": {
        value: this.collectMethod,
        callback: $$v => {
          this.collectMethod = $$v;
        }
      }
    }, [h("a-radio-button", {
      "attrs": {
        "value": "pull"
      }
    }, ["\u62BD\u51FA\u7EC4\u4EF6\u6837\u5F0F"]), h("a-radio-button", {
      "attrs": {
        "value": "copy"
      }
    }, ["\u590D\u5236\u7EC4\u4EF6\u6837\u5F0F"])])])])]) : null]);
  }
  render() {
    const h = arguments[0];
    return h("div", [this.modalMode === 'modal' ? h("a-modal", {
      "attrs": {
        "visible": this.modalVisible,
        "title": this.title,
        "okText": "保存",
        "cancelText": "取消",
        "closable": true,
        "width": this.width
      },
      "on": {
        "change": this.close,
        "ok": this.submitStyleSheet
      }
    }, [this.renderModalContext()]) : null, this.modalMode === 'div' ? h("div", {
      "class": styles.manageModalDiv
    }, [this.renderModalContext(), h("a-button", {
      "attrs": {
        "type": this.styleSheetInternalChanged ? 'primary' : ''
      },
      "on": {
        "click": this.submitStyleSheet
      }
    }, ["\u4FDD\u5B58"])]) : null]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], StyleSheetEditModal.prototype, "designer", void 0);
__decorate([Prop({
  type: String,
  default: 'modal'
})], StyleSheetEditModal.prototype, "modalMode", void 0);
__decorate([Prop({
  type: Boolean,
  required: true
})], StyleSheetEditModal.prototype, "isCreateNew", void 0);
__decorate([Prop({
  type: String
})], StyleSheetEditModal.prototype, "width", void 0);
StyleSheetEditModal = __decorate([Component({
  name: 'StyleSheetEditModal',
  components: {
    StyleNameHeader
  }
})], StyleSheetEditModal);
export { StyleSheetEditModal };
//# sourceMappingURL=StyleSheetEditModal.js.map
